import {Component, OnDestroy, OnInit} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {GridOptions} from 'ag-grid-community';
import * as Constants from '../../../shared/common-components/AppConstants';
import AppConstants, {agency_user, agency_admin_role} from '../../../shared/common-components/AppConstants';
import {User} from '../../../services/user/user';
import {UserService} from '../../../services/user/user.service';
import {AlertService} from '../../../services/alert/alert.service';
import {takeWhile} from 'rxjs/operators';
import _ from 'lodash';
import {Router} from '@angular/router';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {IffShipmentDetailsService} from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import {Subscription, BehaviorSubject} from 'rxjs';
import { formatDate } from '@angular/common';
import {CommonHelpers} from "../../../shared/common-helpers";
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import {IffShipmentSummaryService} from "../../../services/iff-shipment-summary/iff-shipment-summary.service";

@Component({
    selector: 'app-sit-comprehensive-report',
    templateUrl: './sit-comprehensive-report.component.html',
    styleUrls: ['./sit-comprehensive-report.component.css'],
    standalone: false
})
export class SitComprehensiveReportComponent implements OnInit, OnDestroy {
  agency_auditor = Constants.agency_auditor_role;
  agency_admin = Constants.agency_admin_role;
  agency_user = Constants.agency_user;
  carrier_user = Constants.carrier_user;
  carrier_user_admin = Constants.carrier_user_admin;
  carrier_user_RF = Constants.carrier_user_RF;
  system_admin = Constants.system_admin;

  currentUser: User | any;
  private observer$ = new BehaviorSubject(true);
  sitComprehensiveFormGroup: UntypedFormGroup;
  resultsSubscription = new Subscription();
  public reportingYrList = [];
  reportingYr: number;
  reportingQtr = 0;
  currrentYr = 0;

  isRfsp: Boolean;
  rfspCarrierList: any[];
  rfspScacList: any[];
  rfspCarrierId: number;
  selectedCarrierId: number;
  carrierEntity: any;
  selectedTsp: any;

  gridOptions: GridOptions = {
    rowSelection: 'multiple',
    defaultColDef: {
      sortable: true,
      resizable: true,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: false
      }
    },
    pagination: true,
    paginationPageSize: 10,
    cacheBlockSize: 25,
    headerHeight: 50,
    domLayout: 'autoHeight',
    suppressDragLeaveHidesColumns: true,

    overlayLoadingTemplate:
      '<span class="ag-overlay-loading-center">Select the Reporting Year/Quarter to load report.</span>',
    overlayNoRowsTemplate:
      '<span>No results found. Please adjust your filters.</span>'
  };

  format = 'MM/dd/yyyy';
  locale = 'en-US';
  private gridApi;
  public gridColumnApi;
  subArr = [];
  columnsDefs: any;
  rowData: any;
  rowData1: any;

  sitComprensivecolumnDefs = [
    {
      headerName: 'SCAC',
      field: 'scac',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'TSP Name',
      field: 'scacName',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Shipment Report Contact Name',
      valueGetter: (params) => {
        return (params.data.firstName || params.data.lastName || params.data.email) ?
            (params.data.firstName + ' ' + params.data.lastName) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Shipment Report Contact Email',
      valueGetter: (params) => {
        return (params.data.email) ?
            (params.data.email) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'FAIC',
      field: 'faicCode',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'SRO Code',
      field: 'sroCode',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Point of Contact',
      valueGetter: params => {
        return params.data.pofContact ? params.data.pofContact : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Agency Name',
      field: 'agencyName',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Bureau Name',
      field: 'agencyBureauName',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Pro Bill Number',
      field: 'proBillNumber',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'BOL',
      field: 'bolNumber',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'GBL/CBL',
      field: 'gblcbl',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Move Type',
      field: 'moveType',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Transportation Type',
      field: 'transportationType',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Pickup Date',
      valueGetter: (params) => {
        return params.data.pickupDate ? (formatDate(params.data.pickupDate , this.format, this.locale)) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Delivery Date',
      valueGetter: (params) => {
        return params.data.deliveryDate ? (formatDate(params.data.deliveryDate , this.format, this.locale)) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    { // Storage Time
      headerName: 'Time in SIT',
      field: 'transitTime',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Billing Date',
      valueGetter: (params) => {
        return params.data.billingDate ? (formatDate(params.data.billingDate , this.format, this.locale)) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Origin',
      field: 'originStateCode',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Destination',
      field: 'destinationStateCode',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Last Name',
      field: 'employeeLastName',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Weight',
      field: 'weight',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Miles',
      field: 'miles',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Discount',
      field: 'discount',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Gross Amount',
      field: 'grossAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.numberComparator
    },
    {
      headerName: 'Net Amount',
      field: 'netAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      headerName: 'Pass Thru Amt',
      field: 'passThruAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      headerName: 'Reporting Year',
      field: 'reportingYear',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Reporting Quarter',
      field: 'reportingQuarter',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Employee Email Identifier',
      field: 'employeeEmail',
      filter: 'agTextColumnFilter', sortable: true
    }
  ];
  iffAmountCol = {
    headerName: 'Total AF',
    field: 'totalIFF',
    filter: 'agTextColumnFilter',
    sortable: true
  };
  excelStyles = [
    {
       id: 'textFormat',
       dataType: 'string',
     }
   ];

  /**
   * @description defines the button renderer component to show the smartWay button based on the flag.
   */
  constructor(private userService: UserService, private alertService: AlertService, private shipmentDetailService: IffShipmentDetailsService,
    private fb: UntypedFormBuilder, private iffShipmentSummaryService: IffShipmentSummaryService,
    private router: Router, private loader: LoadingService,
    private carrierService: CarrierService) {

  }

  /**
   * initializing the ag-grid
   * @param params
   */
  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.gridApi.setDatasource(this.rowData);
    this.gridColumnApi = params.columnApi;
  }

  /**
   * @description manipulates row data according to the desired results and generates columns dynamically by looping through rowData.
   */
  ngOnInit() {
    this.sitComprehensiveFormGroup = this.fb.group({
      reportingYrSelect: new UntypedFormControl('', Validators.required),
      reportingQtrSelect: new UntypedFormControl('', [Validators.required, Validators.min(0), Validators.max(4)])

    });
    this.currrentYr = new Date().getFullYear();
    this.reportingYrList.push({name: this.currrentYr, value: this.currrentYr});
    for (let i = 1; i < 7; i++) {
      const previousYr = this.currrentYr - i;
      this.reportingYrList.push({name: previousYr, value: previousYr});
    }
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(currentUser => {
        this.currentUser = currentUser;
        this.loadTspsForRfsp();
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.info('unable to get current user details');
      });

  }
  onShipmentReportClicked(){
    this.router.navigate(['/tspSitShpmntRptStatus']);
  }
  getSITCompresensiveDetails() {
    this.loader.show();
    this.resultsSubscription = this.shipmentDetailService.getSITComprehensiveReport(this.reportingYr, this.reportingQtr).subscribe(res => {
     console.log ('res.length ' + res.length);
      if (res !== null && res !== undefined && res.length > 0) {
        this.rowData = CommonHelpers.sortAtoZ(res);
        this.columnsDefs = this.sitComprensivecolumnDefs;
        if (!this.checkUserRole(agency_user) && !this.checkUserRole(agency_admin_role)) {
          this.columnsDefs.splice((this.columnsDefs.length - 3), 0, this.iffAmountCol);
        }
        this.loader.hide();
      } else {
        this.rowData = null;
        this.loader.hide();
      }
    });
  }
  onReportYrChange(reportYr: number) {
    this.reportingYr = reportYr;
  }
  onReportQtrChange(reportQtr: number) {
    this.reportingQtr = reportQtr;
  }
  /**
   *
   * @param: roles
   * @returns: {boolean}
   */
  checkUserRole(roles?) {
    if (this.currentUser) {
      const userRoles = _.map(this.currentUser.roles, x => x.role);
      if (userRoles && userRoles.length > 0) {
        return _.includes(userRoles, roles);
      }
    }
  }

  loadTspsForRfsp(){
    console.log("sy load tsp rfsp");
    this.carrierService.getCarrierByCarrierId(this.currentUser.carrierId).subscribe(carrier => {
      this.carrierEntity = carrier;
      this.isRfsp = this.carrierEntity.carrierType === 'RFSP';
      this.isRfsp ? this.rfspCarrierId = this.carrierEntity.carrierId : this.rfspCarrierId = 0;
      console.log("rsfp carrier id:" + this.rfspCarrierId);
      if(this.isRfsp){
        this.carrierService.getAllRfspsCarriersIff(this.carrierEntity.carrierId).subscribe(
         result => {
           this.rfspCarrierList = result;
           this.rfspCarrierList.sort((a,b) => a.scac > b.scac ? 1 : -1);
           console.log(this.rfspCarrierList);
           this.rfspScacList = this.rfspCarrierList.map(s => s.scac);
           console.log(this.rfspScacList);
         }, error => {
          this.alertService.error('Error while getting rfsp tsp list');
          }
        );
      }
    });

  }

  tspChange(event:any){
    this.selectedTsp = this.sitComprehensiveFormGroup.get('tspListSelect').value;
    console.log(this.selectedTsp);
    let tsp = this.rfspCarrierList.filter(r => r.scac === this.selectedTsp);
    this.selectedCarrierId = tsp[0].carrierId;
    console.log(this.selectedCarrierId);
  }
  /**
   * @description exports all the grid data from the datasource into a csv file using ag-grid api
   */
  onBtExport() {
    const date = new Date();
    const params = {
      fileName: 'sit-comprehensive-report-' + date + '.csv',
      columnSeparator: ','
    };
    this.gridApi.exportDataAsCsv(params);
  }

  ngOnDestroy(): void {
    this.resultsSubscription.unsubscribe();
  }

}
